import moment from 'moment'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { NameAndCodeResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/NameAndCodeResponseDTO'

const SURFACE_WATER_TERM = 'agua superficial'
const WEEKLY_TERM = 'semanal'

/** Termos que identificam a campanha padrão de schemas específicos (além de "água superficial"). */
const SCHEMA_DEFAULT_SAMPLING_TERMS: Record<string, string[]> = {
    cmoc: ['fosfato ouvidor'],
}

/**
 * Valores padrão do filtro do Dashboard, conforme definido pelo cliente.
 */
export class DashboardDefaultsUtils {

    /**
     * Último mês até ontem. Ex.: acesso em 14/09 => 14/08 a 13/09.
     */
    static getDefaultDateRange(): IDateRangeFilter {
        return {
            beginDate: moment().subtract(1, 'month').startOf('day')
                .toDate(),
            endDate: moment().subtract(1, 'day').startOf('day')
                .toDate(),
        }
    }

    /**
     * Campanha de água superficial mensal: nome contém "Água Superficial" e não é semanal.
     * Em schemas com termo específico (ex.: CMOC => Fosfato Ouvidor), prioriza a campanha que também o contém.
     */
    static findDefaultSampling(samplings: NameAndCodeResponseDTO[], schemaSlug?: string): NameAndCodeResponseDTO | undefined {

        const surfaceWater = samplings.filter((sampling) => DashboardDefaultsUtils.normalize(sampling.name).includes(SURFACE_WATER_TERM))
        const monthlySurfaceWater = surfaceWater.filter((sampling) => !DashboardDefaultsUtils.normalize(sampling.name).includes(WEEKLY_TERM))

        const schemaTerms = SCHEMA_DEFAULT_SAMPLING_TERMS[schemaSlug ?? '']
        const schemaSampling = !!schemaTerms
            ? monthlySurfaceWater.find((sampling) => schemaTerms.every((term) => DashboardDefaultsUtils.normalize(sampling.name).includes(term)))
            : undefined

        return schemaSampling ?? monthlySurfaceWater[0] ?? surfaceWater[0] ?? samplings[0]
    }

    /**
     * CONAMA 357 - Água Superficial (Classe 2).
     */
    static findDefaultRegulation(regulations: NameAndCodeResponseDTO[]): NameAndCodeResponseDTO | undefined {
        return regulations.find((regulation) => {
            const name = DashboardDefaultsUtils.normalize(regulation.name)
            return name.includes('357') && name.includes('classe 2')
        })
    }

    /**
     * Oxigênio Dissolvido, priorizando o parâmetro laboratorial ao "in situ".
     */
    static findDefaultField(fields: NameAndCodeResponseDTO[]): NameAndCodeResponseDTO | undefined {
        const dissolvedOxygen = fields.filter((field) => DashboardDefaultsUtils.normalize(field.name).includes('oxigenio dissolvido'))
        return dissolvedOxygen.find((field) => !DashboardDefaultsUtils.normalize(field.name).includes('in situ')) ?? dissolvedOxygen[0]
    }

    /**
     * Nome do empreendimento a partir do slug do schema (ex.: 'serra-verde' => 'Serra Verde').
     */
    static formatSchemaName(slug?: string): string {
        if (!slug)
            return ''

        return slug
            .split(/[-_\s]+/)
            .filter((word) => !!word)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }

    /** Minúsculo e sem acentos, para comparar nomes. */
    static normalize(text?: string): string {
        return (text ?? '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .trim()
    }

}
